import { withProcedureWraper } from "../../../../..";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateNoSalaryForm } from "../../../../absence-letter/components/create-no-salary-leave-form";
export const NoSalaryTSNCreate = withProcedureWraper(() => {
  return (
    <ProcedureLayout title="Tạo đơn xin nghỉ không lương">
      <CreateNoSalaryForm />
    </ProcedureLayout>
  );
});
